<template>
  <social-proof>
    <template #press>
      <div class="press">
        <img
          src="@/assets/homepage/press/vogue.svg"
          loading="lazy"
          alt="Vogue"
          width="142"
          height="37"
        />
        <img
          src="@/assets/homepage/press/forbes.svg"
          loading="lazy"
          alt="Forbes"
          width="142"
          height="38"
        />
        <img
          src="@/assets/homepage/press/bbc-news.svg"
          loading="lazy"
          alt="BBC News"
          width="52"
          height="40"
        />
        <template v-if="$isDesktop">
          <img
            src="@/assets/homepage/press/gq.svg"
            loading="lazy"
            alt="GQ"
            width="82"
            height="40"
          />
          <img
            src="@/assets/homepage/press/cosmopolitan.svg"
            loading="lazy"
            alt="Cosmopolitan"
            width="193"
            height="34"
          />
          <img
            src="@/assets/homepage/press/national-geographic.svg"
            loading="lazy"
            alt="National Geographic"
            width="135"
            height="40"
          />
        </template>
      </div>
    </template>
  </social-proof>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'
import SocialProof from './SocialProof.vue'

@Component({
  mixins: [SocialProof],
})
class SocialProofOthers extends Vue {}

export default toNative(SocialProofOthers)
</script>
